import { AxiosResponse } from "axios"

import { request } from "../../request"

export const getStockStatus = async (
  registration: string
): Promise<AxiosResponse<{status: number, message: string}>> => {
  const regNumber = registration.replace(/\s/g, "")

  const data = {
    RegistrationNumber: regNumber,
  }

  return request({
    url: "/GetStockStatus",
    method: "post",
    headers: {
      "Access-Control-Request-Methods": "*",
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json"
    },
    data: data,
  })
}
